exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.list[data-v-e24e5244]{\r\n    padding: 30px 0;\n}\n.list p[data-v-e24e5244]{\r\n    margin-bottom: 20px;\n}\na[data-v-e24e5244]{\r\n    color: #409eff;\n}\r\n", ""]);

// exports
